import { faLock } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

const Container = styled.div`
  border: 1px dashed ${Colors.Semantic.Neutral.medium_grey};
  border-radius: 0.5rem;
  padding: 1.5rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
`

const LockIcon = styled(FontAwesomeIcon)`
  font-size: 1.125rem;
  color: ${Colors.Semantic.Neutral.dark_grey};
`

const Message = styled.span`
  ${Typography.Body3}
  color: ${Colors.Semantic.Neutral.dark_grey};
`

const ns = 'Listing.actionColumn.actionCard'

export const TlcBreakdownSignInNotice = () => (
  <Container>
    <LockIcon icon={faLock} />
    <Message>
      <FormattedMessage id={`${ns}.tlcBreakdown.signInNotice`} />
    </Message>
  </Container>
)
